export const environment = {
  production: false,
  baseURL: 'http://localhost:4200/',
 apiURL: 'https://staging.tarangplus.in/',
 //apiURL: 'https://cmsapi.tarangplus.in/', 
 // apiURL: 'https://api.tarangplus.in/',



  authtoken:'3zZmzoHg8z6SM3wpDoyw',
  npawaccountcode: 'multitvdev',
  secretKey:'b64617cb2583809729b6',
  appName: 'Tarang',
   appVersion: 'v2.0.1',
    envType:'staging',

  firebase: {
    apiKey: "AIzaSyC4AhxfvdnQyGyHrfrGWgoAHkOQudvNXqI",
    authDomain: "tarangplus-90c37.firebaseapp.com",
    databaseURL: "https://tarangplus-90c37.firebaseio.com",
    projectId: "tarangplus-90c37",
    storageBucket: "tarangplus-90c37.firebasestorage.app",
    messagingSenderId: "42412538134",
    appId: "1:42412538134:web:1b244162174365351bf837",
    measurementId: "G-EMNDESWS80"
  }

  
  
};